import React from "react";
import {
  Input,
  Button,
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHeaderCell,
  TableCell
} from "@sainsburys-tech/fable";
import PropTypes from "prop-types";
import * as allowedRampLevelSeconds from "../../utils/allowedRampLevelSeconds";
import { Delete } from '@sainsburys-tech/icons'
const options = allowedRampLevelSeconds.rampLevelSeconds.map(x => {
  return {
    label: x,
    value: x
  };
});

const StoreZoneSceneLuxBandTable = props => {
  const data = mapData(props.zoneScene);
  return (
    <div>
      <div>
        <Table isResponsive={true} layout="fixed">
          <TableHeader>
            <TableRow>
              <TableHeaderCell>Name</TableHeaderCell>
              <TableHeaderCell key="Lux Level greater than">
                Lux Level greater than (Lux)
              </TableHeaderCell>
              <TableHeaderCell key="Level Percentage">
                Lighting Level (%)
              </TableHeaderCell>
              <TableHeaderCell>Ramp Time (s)</TableHeaderCell>
              <TableHeaderCell />
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map(row => (
              <TableRow key={row.key}>
                <TableCell>{row.name}</TableCell>
                <TableCell>
                  <div className="cb-c-store-zone-scene-lux-band-table__input-field">
                    {row.name !== "Default" ? (
                      <Input
                        name={row.name}
                        value={`${row.luxLevelGreaterThan}`}
                        status={
                          (row.name === "Default"
                            ? props.errors[
                                `${props.zoneScene.scene.name}.${
                                  props.fields.luxLevelGreaterThan.name
                                }`
                              ]
                            : props.errors[
                                `${props.zoneScene.scene.name}.${
                                  props.fields.luxLevelGreaterThan.name
                                }.${row.key}`
                              ])
                            ? { type: "error", message: (row.name === "Default"
                                ? props.errors[
                                    `${props.zoneScene.scene.name}.${
                                      props.fields.luxLevelGreaterThan.name
                                    }`
                                  ]
                                : props.errors[
                                    `${props.zoneScene.scene.name}.${
                                      props.fields.luxLevelGreaterThan.name
                                    }.${row.key}`
                                  ]) }
                            : undefined
                        }
                        onChange={e =>
                          row.name === "Default"
                            ? props.handleInputChange(
                                props.scene,
                                props.fields.luxLevelGreaterThan,
                                e.target.value
                              )
                            : props.handleInputChange(
                                props.scene,
                                props.fields.luxLevelGreaterThan,
                                e.target.value,
                                row.index,
                                row.key
                              )
                        }
                        className="fable:mb-0"
                      />
                    ) : (
                      "-"
                    )}
                  </div>{" "}
                </TableCell>
                <TableCell>
                  <div className="cb-c-store-zone-scene-lux-band-table__input-field">
                    <Input
                      name={row.name}
                      value={`${row.levelPercentage}`}
                      status={
                        (row.name === "Default"
                          ? props.errors[
                              `${props.zoneScene.scene.name}.${
                                props.fields.valuePercentage.name
                              }`
                            ]
                          : props.errors[
                              `${props.zoneScene.scene.name}.${
                                props.fields.valuePercentage.name
                              }.${row.key}`
                            ])
                          ? { type: "error", message: (row.name === "Default"
                              ? props.errors[
                                  `${props.zoneScene.scene.name}.${
                                    props.fields.valuePercentage.name
                                  }`
                                ]
                              : props.errors[
                                  `${props.zoneScene.scene.name}.${
                                    props.fields.valuePercentage.name
                                  }.${row.key}`
                                ]) }
                          : undefined
                      }
                      onChange={e =>
                        row.name === "Default"
                          ? props.handleInputChange(
                              props.scene,
                              props.fields.valuePercentage,
                              e.target.value
                            )
                          : props.handleInputChange(
                              props.scene,
                              props.fields.valuePercentage,
                              e.target.value,
                              row.index,
                              row.key
                            )
                      }
                      className="fable:mb-0"
                    />
                  </div>
                </TableCell>
                <TableCell>
                  <div className="cb-c-store-zone-scene-lux-band-table__select-field">
                    <Input
                      name={row.name}
                      value={`${row.rampLevelSeconds}`}
                      status={
                        (row.name === "Default"
                          ? props.errors[
                              `${props.zoneScene.scene.name}.${
                                props.fields.rampLevelSeconds.name
                              }`
                            ]
                          : props.errors[
                              `${props.zoneScene.scene.name}.${
                                props.fields.rampLevelSeconds.name
                              }.${row.key}`
                            ])
                          ? { type: "error", message: (row.name === "Default"
                              ? props.errors[
                                  `${props.zoneScene.scene.name}.${
                                    props.fields.rampLevelSeconds.name
                                  }`
                                ]
                              : props.errors[
                                  `${props.zoneScene.scene.name}.${
                                    props.fields.rampLevelSeconds.name
                                  }.${row.key}`
                                ]) }
                          : undefined
                      }
                      onChange={e =>
                        row.name === "Default"
                          ? props.handleInputChange(
                              props.scene,
                              props.fields.rampLevelSeconds,
                              e.target.value
                            )
                          : props.handleInputChange(
                              props.scene,
                              props.fields.rampLevelSeconds,
                              e.target.value,
                              row.index,
                              row.key
                            )
                      }
                      className="fable:mb-0"
                    />
                  </div>
                </TableCell>
                <TableCell>
                  {row.name !== "Default" ? (
                    <Button
                      variant="ghost"
                      onClick={e =>
                        props.onRemoveLuxBand(
                          props.zoneScene.scene.name,
                          row.key,
                          row.index
                        )
                      }
                      title="Delete"
                    >
                      <Delete />
                    </Button>
                  ) : (
                    ""
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <br />
      <Button
        variant="secondary"
        onClick={e => props.onAddLuxBand(props.zoneScene.scene.name)}
      >
        Add new lux band
      </Button>
    </div>
  );
};

const mapData = zoneScene => {
  const dataArray = zoneScene.luxBands.map((luxBand, index) => {
    return {
      name: "Lux Band " + (index + 1),
      luxLevelGreaterThan: luxBand.luxLevelGreaterThan,
      levelPercentage: luxBand.level.valuePercentage,
      rampLevelSeconds: luxBand.rampLevelSeconds,
      index: index,
      key: luxBand.key
    };
  });

  dataArray.unshift({
    name: "Default",
    luxLevelGreaterThan: 2501,
    levelPercentage: zoneScene.value.level.valuePercentage,
    rampLevelSeconds: zoneScene.value.rampLevelSeconds,
    key: "Default"
  });

  return dataArray;
};

StoreZoneSceneLuxBandTable.propTypes = {
  fields: PropTypes.shape({
    valuePercentage: PropTypes.shape({
      name: PropTypes.string,
      rules: PropTypes.array
    }),
    rampLevelSeconds: PropTypes.shape({
      name: PropTypes.string,
      rules: PropTypes.array
    }),
    luxLevelGreaterThan: PropTypes.shape({
      name: PropTypes.string,
      rules: PropTypes.array
    })
  }).isRequired,

  errors: PropTypes.shape({}).isRequired,

  scene: PropTypes.string.isRequired
};

export default StoreZoneSceneLuxBandTable;
